let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9uNix"), load("7jBYv"), load("c6MKV"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));